import { faDownload } from "@fortawesome/pro-regular-svg-icons/faDownload";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import { faEraser } from "@fortawesome/pro-regular-svg-icons/faEraser";

export default [
	faDownload, faMagnifyingGlass, faEraser
];
